/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2025-03-15 11:08:27
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2026-03-10 10:45:46
 * @FilePath: \vue-hd-ota\src\views\firmware\js\formConfig.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 固件列表查询
const QueryForm = {
    labelCol: { style: { width: '100px' } },
    wrapperCol: { span: 14 },
    formData:{},
    formField:[
        // {
        //     // name:'硬件版本',
        //     key:'hardware_version',
        //     type:'input',
        //     allowClear:true,
        //     width:'180px',
        //     placeholder_lang:'按硬件版本查询',
        // },
        // {
        //     // name:'软件版本',
        //     key:'software_version',
        //     type:'input',
        //     allowClear:true,
        //     width:'180px',
        //     placeholder_lang:'按软件版本查询',
        // },
        // {
        //     // name:'固件描述',
        //     key:'file_desc',
        //     type:'input',
        //     allowClear:true,
        //     width:'180px',
        //     placeholder_lang:'按固件描述查询',
        // },
        {
            // name:'客户名称',
            key:'customer_name',
            type:'input',
            allowClear:true,
            width:'180px',
            placeholder_lang:'按客户名称查询',
        },
        {
            // name:'车厂名称',
            key:'manufacturer_name',
            type:'input',
            allowClear:true,
            width:'180px',
            placeholder_lang:'按车厂名称查询',
        },
        {
            // name:'车型名称',
            key:'model_name',
            type:'input',
            allowClear:true,
            width:'180px',
            placeholder_lang:'按车型名称查询',
        },
        {
            // name:'硬件平台名称',
            key:'hardware_platform_name',
            type:'input',
            allowClear:true,
            width:'180px',
            placeholder_lang:'按硬件平台名称查询',
        },
        {
            // name:'状态',
            key:'status',
            type:'select',
            allowClear:true,
            width:'180px',
            placeholder_lang:'按状态查询',
            options:[
                {
                    label:'firmware.release',
                    value:0,
                },
                {
                    label:'firmware.test',
                    value:1,
                },
                {
                    label:'firmware.cancel',
                    value:2,
                },
            ]
        },
        {
            // name:'环境',
            key:'environment',
            type:'select',
            allowClear:true,
            width:'180px',
            placeholder_lang:'按环境查询',
            options:[
                {
                    label:'firmware.product',
                    value:0,
                },
                {
                    label:'firmware.test',
                    value:1,
                },
            ]
        },
    ]
}


QueryForm.formField.forEach(item=>{
    QueryForm.formData[item.key] = ''
    if(item.key == 'environment' || item.key == 'status'){
        QueryForm.formData[item.key] = null
    }
})

export {
    QueryForm
}